import React, { useEffect, useState, useMemo, useRef } from 'react';
import './App.css';
import Search from './Search';
import AboutUs from './AboutUs';
import ShoppingCart from './ShoppingCart';
import AllProducts from './AllProducts';
import Checkout from './Checkout';
import ShippingOptions from './ShippingOptions';
import OrderConfirmation from './OrderConfirmation';
import Disclaimer from './Disclaimer';
import Jokes from './Jokes';
import CorporateLifeHacks from './CorporateLifeHacks';
import GloriousIncompetence from './GloriousIncompetence';
import StupidServices from './StupidServices';
import StupidSystemDesigns from './StupidSystemDesigns';
import ElevatorDesign from './ElevatorDesign';
import CacheDesign from './CacheDesign';
import ATMDesign from './ATMDesign';
import VendingMachineDesign from './VendingMachineDesign';
import SlotBookingsDesign from './SlotBookingsDesign';
import ParkingGarageDesign from './ParkingGarageDesign';
import PasteBinDesign from './PasteBinDesign';
import RateLimiterDesign from './RateLimiterDesign';
import SplitwiseDesign from './SplitwiseDesign';
import FileSystemDesign from './FileSystemDesign';
import HashSetDesign from './HashSetDesign';
import ElasticSearchDesign from './ElasticSearchDesign';
import AmazonLockerDesign from './AmazonLockerDesign';
import EventSchedulerDesign from './EventSchedulerDesign';
import UberDesign from './UberDesign';
import GamesDesign from './GamesDesign';
import BattleshipDesign from './BattleshipDesign';
import InventoryPackingDesign from './InventoryPackingDesign';
import SpellCheckerDesign from './SpellCheckerDesign';
import FriendRecommenderDesign from './FriendRecommenderDesign';
import MazeSolverDesign from './MazeSolverDesign';
import TaskSchedulerDesign from './TaskSchedulerDesign';
import Clown from './Clown';
import ReactGA from "react-ga4";

ReactGA.initialize("G-TSE430Z7X7");

const CART_STORAGE_KEY = 'uselessProductsCart';

const loadSessionCart = () => {
  if (typeof window === 'undefined') return {};
  try {
    return JSON.parse(window.sessionStorage.getItem(CART_STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
};

const saveSessionCart = (cart) => {
  if (typeof window === 'undefined') return;
  window.sessionStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
};

const getAbsurdPrice = () => Math.floor(Math.random() * 1000001);

const formatPrice = (value) => {
  return value.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  });
};

const MENU_ITEMS = [
  { page: 'main', label: 'Home Page' },
  { page: 'system-designs', label: 'System Designs' },
  { page: 'services', label: 'Services' },
  { page: 'all', label: 'Products' },
  { page: 'jokes', label: 'Jokes' },
  { page: 'incompetence', label: 'Incompetence' },
  { page: 'search', label: 'Search Page' },
  { page: 'corporate', label: 'Corporate Life Hacks' },
  { page: 'clown', label: 'CLOWNS' },
  { page: 'about', label: 'About Us' },
  { page: 'cart', label: 'Shopping Cart' },
];

function Header({ theme, currentPage, searchQuery, setSearchQuery, onSearch, toggleTheme, menuOpen, toggleMenu, onNavigate, isServerReady, serverStatus, cartQuantity }) {
  return (
    <>
      <header className="header">
        <div className="header-brand">
          <div className="logo"><span><s> Practically</s></span> <span className="highlight"> Stupidly</span> Designed Products</div>
          <p className="brand-subtitle">A personally curated list of intentionally stupid inventions.</p>
        </div>

        <form className="search-container" onSubmit={onSearch}>
          <input
            type="text"
            className="search-bar"
            placeholder="Search products..."
            value={searchQuery}
            onChange={(event) => setSearchQuery(event.target.value)}
            disabled={!isServerReady}
          />
          <button className="search-btn" type="submit" disabled={!isServerReady}>
            {serverStatus === 'connecting' ? "Loading.." : "Search"}
          </button>
        </form>

        <div className="header-actions">
          <button
            type="button"
            className="cart-toggle"
            aria-label="View shopping cart"
            onClick={() => onNavigate('cart')}
          >
            <span className="cart-icon" aria-hidden="true">🛒</span>
            <span className="cart-count">{cartQuantity}</span>
          </button>
          <button
            type="button"
            className="menu-toggle"
            aria-expanded={menuOpen}
            aria-label="Toggle navigation menu"
            onClick={toggleMenu}
          >
            <span className="menu-icon" aria-hidden="true">
              <span />
              <span />
              <span />
            </span>
            <span className="menu-label">Menu</span>
          </button>
          <button className="theme-toggle" onClick={toggleTheme}>
            {theme === 'dark' ? '🌙' : '☀️'}
          </button>
        </div>
      </header>

      <nav
        className={`nav-menu ${menuOpen ? 'open' : ''}`}
        aria-hidden={!menuOpen}
        onClick={toggleMenu}
      >
        <div className="nav-menu-content" onClick={(e) => e.stopPropagation()}>
          <div className="nav-menu-header">
            <h2>Navigation</h2>
            <button
              type="button"
              className="nav-menu-close"
              aria-label="Close menu"
              onClick={toggleMenu}
            >
              ✕
            </button>
          </div>
          {MENU_ITEMS.map((item) => (
            <button
              key={item.page}
              type="button"
              className={`nav-link ${currentPage === item.page ? 'active' : ''}`}
              onClick={() => onNavigate(item.page)}
            >
              {item.label}
            </button>
          ))}
        </div>
      </nav>
    </>
  );
}

const DATA = [
  { id: 22, name: "Inflatable Anchor", desc: "Lightweight and easy to carry. Once deployed, it floats gracefully on the surface while your boat drifts away.", img: "https://tajpggkeslwptgqgswyi.supabase.co/storage/v1/object/public/product-images/Lucid_Origin_A_brightly_colored_comedically_lightweight_anchor_0.jpg" },
  { id: 2, name: "Waterproof Towel", desc: "Stay wet efficiently. Our hydrophobic fibers ensure the towel never absorbs a drop, leaving you as soaked as the moment you stepped out.", img: "https://tajpggkeslwptgqgswyi.supabase.co/storage/v1/object/public/product-images/lucid-origin_A_waterproof_towel._The_towel_looks_like_it_is_scared_of_water_and_running_away_-0.jpg" },
  { id: 21, name: "Solar Flashlight", desc: "A revolution in eco-lighting. Works perfectly in broad daylight. Automatically deactivates in darkness to save energy.", img: "https://tajpggkeslwptgqgswyi.supabase.co/storage/v1/object/public/product-images/pexels-leondark-18678168.jpg" },
  { id: 28, name: "Glass Hammer", desc: "The ultimate aesthetic tool. Features a transparent glass handle and head. Guaranteed to shatter on first impact.", img: "https://tajpggkeslwptgqgswyi.supabase.co/storage/v1/object/public/product-images/IMG_20260405_200259.png" },
  { id: 23, name: "Screenless Phone", desc: "Reconnect with reality. A premium titanium block with zero distractions. No battery required.", img: "https://tajpggkeslwptgqgswyi.supabase.co/storage/v1/object/public/product-images/Lucid_Origin_A_retrofuturistic_smartphone_with_a_distinctive_d_0.jpg" },
];

const CURRENT_PAGE_KEY = 'useless-products-current-page';

function App() {
  const [theme, setTheme] = useState('dark');
  const [currentPage, setCurrentPage] = useState(() => {
    if (typeof window === 'undefined') return 'main';
    return window.sessionStorage.getItem(CURRENT_PAGE_KEY) || 'main';
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const [quantityById, setQuantityById] = useState({});
  const [cartMessage, setCartMessage] = useState('');
  const [cartQuantity, setCartQuantity] = useState(() => {
    const cart = loadSessionCart();
    return Object.values(cart).reduce((total, item) => total + Number(item.quantity || 0), 0);
  });

  const getRandomExhibit = () => DATA[Math.floor(Math.random() * DATA.length)];
  const initialExhibit = getRandomExhibit();
  const [exhibit] = useState(initialExhibit);
  const [products, setProducts] = useState(() => DATA.filter(p => p.id !== initialExhibit.id));
  const [isLoading, setIsLoading] = useState(false);
  const [serverStatus, setServerStatus] = useState('connecting');
  const statusRef = useRef(serverStatus);
  const [statusVisible, setStatusVisible] = useState(true);
  const isServerReady = serverStatus === 'connected';
  const productsSectionRef = useRef(null);

  const productPriceFor = (productId) => {
    const cart = loadSessionCart();
    const existing = cart[String(productId)];
    return existing?.price ?? getAbsurdPrice();
  };

  const syncCartQuantity = () => {
    const cart = loadSessionCart();
    setCartQuantity(Object.values(cart).reduce((total, item) => total + Number(item.quantity || 0), 0));
  };

  const updateCart = (product, quantity) => {
    if (!product || quantity < 1) return;

    const id = String(product.id);
    const cart = loadSessionCart();
    const existing = cart[id] || {};
    const unitPrice = existing.price ?? getAbsurdPrice();
    const quantityToAdd = Number(quantity) || 1;

    cart[id] = {
      id,
      name: product.name,
      desc: product.desc,
      img: product.img || '',
      price: unitPrice,
      quantity: (existing.quantity || 0) + quantityToAdd,
    };

    saveSessionCart(cart);
    syncCartQuantity();
    setQuantityById((prev) => ({ ...prev, [id]: 1 }));
    setCartMessage(`Added ${quantityToAdd} × ${product.name} at ${formatPrice(unitPrice)} each.`);
    window.setTimeout(() => setCartMessage(''), 3200);
  };

  const handleQuantityInput = (productId, value) => {
    const normalized = Math.max(1, Number(value) || 1);
    setQuantityById((prev) => ({ ...prev, [productId]: normalized }));
  };

  const toggleTheme = () => {
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setCurrentPage('search');
    setMenuOpen(false);
  };

  const handleBackToMain = () => {
    setCurrentPage('main');
    setMenuOpen(false);
  };

  const toggleMenu = () => setMenuOpen((open) => !open);
  const handleNavigate = (page) => {
    setCurrentPage(page);
    setMenuOpen(false);
  };
  const handlePlaceOrderClick = () => {
    setCurrentPage('checkout');
    setMenuOpen(false);
  };

  const handleProceedToShipping = () => {
    setCurrentPage('shipping');
    setMenuOpen(false);
  };

  const [selectedPartner, setSelectedPartner] = useState(null);
  const [orderDetails, setOrderDetails] = useState(null);

  const handleShippingSelected = (partner) => {
    const cartItems = Object.values(loadSessionCart());
    const placedAt = new Date();
    const orderNumber = `NAN-${placedAt.getFullYear()}${(placedAt.getMonth() + 1).toString().padStart(2, '0')}${placedAt.getDate().toString().padStart(2, '0')}-${placedAt.getHours().toString().padStart(2, '0')}${placedAt.getMinutes().toString().padStart(2, '0')}-${Math.floor(Math.random() * 900 + 100)}`;
    const totalPrice = cartItems.reduce((sum, item) => sum + Number(item.price || 0) * Number(item.quantity || 0), 0);

    setOrderDetails({
      orderNumber,
      shippingMethod: partner,
      placedAt: placedAt.toISOString(),
      items: cartItems,
      totalPrice,
    });
    setSelectedPartner(partner);
    saveSessionCart({});
    syncCartQuantity();
    setCurrentPage('order-confirmation');
    setMenuOpen(false);
  };

  const handleBackFromOrderConfirmation = () => {
    saveSessionCart({});
    syncCartQuantity();
    setCurrentPage('main');
    setMenuOpen(false);
  };

  const pageHeader = (
    <Header
      theme={theme}
      currentPage={currentPage}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      onSearch={handleSearch}
      toggleTheme={toggleTheme}
      menuOpen={menuOpen}
      toggleMenu={toggleMenu}
      onNavigate={handleNavigate}
      isServerReady={isServerReady}
      serverStatus={serverStatus}
      cartQuantity={cartQuantity}
    />
  );

  const normalizeApiProduct = (product) => {
    if (!product) return { id: Math.random(), name: "Unknown Glitch", desc: "This product is so useless it doesn't even exist.", img: "" };

    return {
      id: product.id || Math.random(),
      name: product.productName ?? product.name ?? "Unnamed Inutility",
      desc: product.description ?? product.desc ?? "No description provided, likely because there's nothing to say about this.",
      img: product.imagePath
        ? (product.imagePath.startsWith('http')
          ? product.imagePath
          : `https://tajpggkeslwptgqgswyi.supabase.co/storage/v1/object/public/product-images/${product.imagePath}`)
        : null,
    };
  };

  const elevatorDesignCode = `#include <bits/stdc++.h>
using namespace std;

enum class Direction { UP, DOWN, IDLE };

class Elevator {
    int id;
    int floor;
    Direction direction;
    set<int> requests;

public:
    explicit Elevator(int elevatorId)
        : id(elevatorId), floor(0), direction(Direction::IDLE) {}

    int getId() const { return id; }
    int getFloor() const { return floor; }
    Direction getDirection() const { return direction; }

    void addFloor(int floorId) {
        requests.insert(floorId);
    }

    void removeFloor(int floorId) {
        requests.erase(floorId);
    }

    void tick() {
        if (requests.count(floor)) {
            requests.erase(floor);
            cout << "Elevator " << id << " opened at floor " << floor << '\n';
            return;
        }

        if (requests.empty()) {
            direction = Direction::IDLE;
            return;
        }

        if (direction == Direction::IDLE) {
            int bestFloor = *requests.begin();
            int minDistance = INT_MAX;

            for (int reqFloor : requests) {
                int distance = abs(floor - reqFloor);
                if (distance < minDistance) {
                    minDistance = distance;
                    bestFloor = reqFloor;
                }
            }

            direction = (bestFloor < floor) ? Direction::DOWN : Direction::UP;
        }

        if (direction == Direction::UP) {
            if (floor < 9) {
                ++floor;
            } else {
                direction = Direction::DOWN;
                --floor;
            }
        } else if (direction == Direction::DOWN) {
            if (floor > 0) {
                --floor;
            } else {
                direction = Direction::UP;
                ++floor;
            }
        }
    }
};

class ElevatorController {
    vector<Elevator> elevators;

public:
    ElevatorController() {
        for (int i = 1; i <= 3; ++i) {
            elevators.emplace_back(i);
        }
    }

    int getDistance(Direction dir1, int floor1, Direction dir2, int floor2) const {
        if (dir1 == Direction::UP) {
            if (dir2 == Direction::UP) {
                return (floor1 >= floor2) ? floor1 - floor2 : 100 + abs(floor1 - floor2);
            }
            if (dir2 == Direction::IDLE) return abs(floor1 - floor2);
            return 10 + floor1 + floor2;
        }

        if (dir2 == Direction::DOWN) {
            return (floor1 <= floor2) ? floor2 - floor1 : 100 + floor1 - floor2;
        }
        if (dir2 == Direction::IDLE) return abs(floor1 - floor2);
        return 10 + floor1 + floor2;
    }

    void callElevator(int floor, Direction dir) {
        if (floor < 0 || floor > 9) {
            cout << "Elevator call failed: invalid floor\n";
            return;
        }

        int bestElevatorIdx = -1;
        int bestDistance = INT_MAX;

        for (int i = 0; i < static_cast<int>(elevators.size()); ++i) {
            int elevatorFloor = elevators[i].getFloor();
            Direction elevatorDir = elevators[i].getDirection();
            int distance = getDistance(dir, floor, elevatorDir, elevatorFloor);

            if (distance < bestDistance) {
                bestDistance = distance;
                bestElevatorIdx = i;
            }
        }

        elevators[bestElevatorIdx].addFloor(floor);
        cout << "Elevator call success: elevator " << bestElevatorIdx + 1 << " is assigned!\n";
    }

    void pressFloor(int elevatorId, int floor) {
        elevators[elevatorId - 1].addFloor(floor);
        cout << "Floor " << floor << " pressed for elevator " << elevatorId << '\n';
    }

    void simulateTick() {
        for (auto &elevator : elevators) {
            elevator.tick();
        }
    }
};

int main() {
    ElevatorController controller;

    cout << "--- Starting Elevator Simulation ---\n";

    controller.callElevator(5, Direction::UP);
    controller.callElevator(8, Direction::DOWN);
    controller.callElevator(2, Direction::UP);

    for (int t = 1; t <= 40; ++t) {
        cout << "\n[Time: " << t << "]\n";

        if (t == 6) {
            controller.pressFloor(1, 9);
        }
        if (t == 15) {
            controller.callElevator(0, Direction::UP);
        }

        controller.simulateTick();
    }

    return 0;
}`;

  useEffect(() => {
    statusRef.current = serverStatus;
  }, [serverStatus]);

  useEffect(() => {
    const pagePath = currentPage === 'main'
      ? '/home'
      : currentPage === 'search'
        ? '/search'
        : currentPage === 'jokes'
          ? '/jokes'
          : currentPage === 'services'
            ? '/services'
            : currentPage === 'system-designs'
              ? '/system-designs'
              : currentPage === 'elevator-design'
                ? '/elevator-design'
                : currentPage === 'cache-design'
                  ? '/cache-design'
                  : currentPage === 'atm-design'
                    ? '/atm-design'
                    : currentPage === 'vending-machine-design'
                      ? '/vending-machine-design'
                      : currentPage === 'amazon-locker-design'
                        ? '/amazon-locker-design'
                        : currentPage === 'event-scheduler-design'
                          ? '/event-scheduler-design'
                          : currentPage === 'uber-design'
                            ? '/uber-design'
                            : currentPage === 'games-design'
                              ? '/games-design'
                              : currentPage === 'battleship-design'
                                ? '/battleship-design'
                                : currentPage === 'inventory-packing-design'
                                  ? '/inventory-packing-design'
                                  : currentPage === 'spell-checker-design'
                                    ? '/spell-checker-design'
                                    : currentPage === 'friend-recommender-design'
                                      ? '/friend-recommender-design'
                                      : currentPage === 'maze-solver-design'
                                        ? '/maze-solver-design'
                                        : currentPage === 'task-scheduler-design'
                                          ? '/task-scheduler-design'
                              : `/${currentPage}`;

    const pageTitle = currentPage === 'main'
      ? 'Home Page'
      : currentPage === 'search'
        ? 'Search Page'
        : currentPage === 'jokes'
          ? 'Bad Jokes'
          : currentPage === 'corporate'
            ? 'Life'
            : currentPage === 'incompetence'
              ? 'Incompetence'
              : currentPage === 'services'
                ? 'Services'
                : currentPage === 'system-designs'
                  ? 'System Designs'
                  : currentPage === 'elevator-design'
                    ? 'Elevator Design'
                    : currentPage === 'cache-design'
                      ? 'Cache Design'
                      : currentPage === 'atm-design'
                        ? 'ATM Design'
                        : currentPage === 'vending-machine-design'
                          ? 'Vending Machine Design'
                          : currentPage === 'hashset-design'
                            ? 'HashSet Design'
                            : currentPage === 'elasticsearch-design'
                              ? 'Elasticsearch Design'
                              : currentPage === 'amazon-locker-design'
                                ? 'Amazon Locker Design'
                                : currentPage === 'event-scheduler-design'
                                  ? 'Event Scheduler Design'
                                  : currentPage === 'uber-design'
                                    ? 'Uber Design'
                                    : currentPage === 'games-design'
                                      ? 'Games Low Level Design'
                                      : currentPage === 'battleship-design'
                                        ? 'Battleship Low Level Design'
                                        : currentPage === 'inventory-packing-design'
                                          ? 'Inventory Packing Low Level Design'
                                          : currentPage === 'spell-checker-design'
                                            ? 'Spell Checker Low Level Design'
                                            : currentPage === 'friend-recommender-design'
                                              ? 'Friend Recommender Low Level Design'
                                              : currentPage === 'maze-solver-design'
                                                ? 'Maze Solver & Route Planner LLD'
                                                : currentPage === 'task-scheduler-design'
                                                  ? 'Task Scheduler LLD'
                                      : currentPage === 'clown'
                                        ? 'CLOWNS PAGE'
                                        : `${currentPage.charAt(0).toUpperCase()}${currentPage.slice(1)}`;

    ReactGA.send({
      hitType: "pageview",
      page: pagePath,
      title: pageTitle
    });
  }, [currentPage]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.sessionStorage.setItem(CURRENT_PAGE_KEY, currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentPage]);

  useEffect(() => {
    let successTimer;
    let retryTimer;
    let controller = new AbortController();

    const checkHealth = async () => {
      window.clearTimeout(retryTimer);
      window.clearTimeout(successTimer);
      controller.abort();
      controller = new AbortController();

      if (statusRef.current !== 'connected') {
        setServerStatus('connecting');
        setStatusVisible(true);
      }

      try {
        const response = await fetch('https://useless-products-backend.onrender.com/api/v1/health', {
          signal: controller.signal
        });

        if (response.ok) {
          setServerStatus('connected');
          successTimer = window.setTimeout(() => setStatusVisible(false), 10000);
        } else {
          throw new Error("Server Response Error");
        }
      } catch (error) {
        if (error.name === 'AbortError') return;

        console.log("Attempt failed, trying again in 20s...");
        setServerStatus('failed');
        setStatusVisible(true);

        retryTimer = window.setTimeout(checkHealth, 20000);
      }
    };

    checkHealth();

    return () => {
      window.clearTimeout(successTimer);
      window.clearTimeout(retryTimer);
      controller.abort();
    };
  }, []);

  const refreshProducts = async () => {
    if (!exhibit || !isServerReady || isLoading) return;
    const controller = new AbortController();
    setIsLoading(true);
    try {
      const response = await fetch(
        `https://useless-products-backend.onrender.com/api/v1/products/random?total=8&excludeId=${exhibit.id}`
        , { signal: controller.signal }
      );
      if (!response.ok) {
        throw new Error(`Failed to fetch products: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      const fetchedProducts = Array.isArray(data.products)
        ? data.products.map(normalizeApiProduct)
        : [];

      setProducts(fetchedProducts);
    } catch (error) {
      if (error.name === 'AbortError') return;
      console.error('Error fetching products:', error);
      const fallback = [...DATA.filter(p => p.id !== exhibit.id)].sort(() => Math.random() - 0.5);
      setProducts(fallback);
    } finally {
      setIsLoading(false);
      if (productsSectionRef.current) {
        const topPosition = productsSectionRef.current.getBoundingClientRect().top + window.scrollY - 100;
        window.scrollTo({
          top: topPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  const shuffledBorderColors = useMemo(() => {
    const baseColors = theme === 'dark'
      ? ['#5c46c3', '#2d64b8', '#4e8e31', '#4a7a8c', '#7d5ba6', '#3e5d8a']
      : ['#a579ff', '#63b5ff', '#8be783', '#8ecae6', '#b8bedd', '#98c1d9'];

    const shuffled = [...baseColors];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }, [theme]);

  if (currentPage === 'search') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <Search
          theme={theme}
          toggleTheme={toggleTheme}
          searchQuery={searchQuery}
          onBackClick={handleBackToMain}
          onCartUpdated={syncCartQuantity}
        />
      </div>
    );
  }

  if (currentPage === 'all') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <AllProducts
          theme={theme}
          onBackClick={handleBackToMain}
        />
      </div>
    );
  }

  if (currentPage === 'about') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <AboutUs
          theme={theme}
          onBackClick={handleBackToMain}
        />
      </div>
    );
  }

  if (currentPage === 'jokes') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <Jokes
          theme={theme}
          onBackClick={handleBackToMain}
          onAddToCart={updateCart}
        />
      </div>
    );
  }

  if (currentPage === 'corporate') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <CorporateLifeHacks
          theme={theme}
          onBackClick={handleBackToMain}
        />
      </div>
    );
  }

  if (currentPage === 'incompetence') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <GloriousIncompetence
          theme={theme}
          onBackClick={handleBackToMain}
        />
      </div>
    );
  }

  if (currentPage === 'services') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <StupidServices
          theme={theme}
          onBackClick={handleBackToMain}
          onAddToCart={updateCart}
        />
      </div>
    );
  }

  if (currentPage === 'system-designs') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <StupidSystemDesigns
          theme={theme}
          onBackClick={handleBackToMain}
          onOpenDesign={(designId) => handleNavigate(
            designId === 'elevator-design' || designId === 'cache-design' || designId === 'atm-design' || designId === 'vending-machine-design' || designId === 'slot-bookings-design' || designId === 'parking-garage' || designId === 'paste-bin-design' || designId === 'rate-limiter-design' || designId === 'splitwise-design' || designId === 'file-system-design' || designId === 'hashset-design' || designId === 'elasticsearch-design' || designId === 'amazon-locker-design' || designId === 'event-scheduler-design' || designId === 'uber-design' || designId === 'games-design' || designId === 'battleship-design' || designId === 'inventory-packing-design' || designId === 'spell-checker-design' || designId === 'friend-recommender-design' || designId === 'maze-solver-design' || designId === 'task-scheduler-design' ? designId : 'system-designs'
          )}
          onAddToCart={updateCart}
        />
      </div>
    );
  }

  if (currentPage === 'elevator-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <ElevatorDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'cache-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <CacheDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'atm-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <ATMDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'vending-machine-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <VendingMachineDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'slot-bookings-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <SlotBookingsDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'parking-garage') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <ParkingGarageDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'paste-bin-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <PasteBinDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'rate-limiter-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <RateLimiterDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'splitwise-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <SplitwiseDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'file-system-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <FileSystemDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'hashset-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <HashSetDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'elasticsearch-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <ElasticSearchDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'amazon-locker-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <AmazonLockerDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'event-scheduler-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <EventSchedulerDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'uber-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <UberDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'games-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <GamesDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'battleship-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <BattleshipDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'inventory-packing-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <InventoryPackingDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'spell-checker-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <SpellCheckerDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'friend-recommender-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <FriendRecommenderDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'maze-solver-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <MazeSolverDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'task-scheduler-design') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <TaskSchedulerDesign
          theme={theme}
          onBackClick={() => handleNavigate('system-designs')}
        />
      </div>
    );
  }

  if (currentPage === 'clown') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <Clown theme={theme} />
      </div>
    );
  }

  if (currentPage === 'cart') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <ShoppingCart
          theme={theme}
          onBackClick={handleBackToMain}
          onCartUpdated={syncCartQuantity}
          onPlaceOrderClick={handlePlaceOrderClick}
        />
      </div>
    );
  }

  if (currentPage === 'checkout') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <Checkout
          theme={theme}
          onBackClick={() => handleNavigate('cart')}
          onPlaceOrder={handleProceedToShipping}
        />
      </div>
    );
  }

  if (currentPage === 'shipping') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <ShippingOptions
          theme={theme}
          onBackClick={() => handleNavigate('checkout')}
          onConfirm={handleShippingSelected}
        />
      </div>
    );
  }

  if (currentPage === 'order-confirmation') {
    return (
      <div className={`app ${theme}`}>
        {pageHeader}
        <OrderConfirmation
          theme={theme}
          onBackClick={handleBackFromOrderConfirmation}
          orderDetails={orderDetails}
        />
      </div>
    );
  }

  return (
    <div className={`app ${theme}`}>
      {pageHeader}
      {cartMessage && (
        <div className="cart-toast">
          {cartMessage}
        </div>
      )}

      <main>
        <Disclaimer theme={theme} />
        <section className="exhibit-hero">
          <div className="exhibit-card">
            <div className="exhibit-copy">
              <span className="eyebrow">In the spotlight</span>
              <h1>{exhibit.name}</h1>
              <p>{exhibit.desc}</p>

              <div className="hero-purchase-row">
                <span className="hero-price">{formatPrice(productPriceFor(exhibit.id))}</span>
                <label className="qty-label">
                  Qty
                  <input
                    type="number"
                    min="1"
                    value={quantityById[exhibit.id] ?? 1}
                    onChange={(event) => handleQuantityInput(exhibit.id, event.target.value)}
                  />
                </label>
                <button
                  className="add-cart-btn"
                  onClick={() => updateCart(exhibit, quantityById[exhibit.id] ?? 1)}
                >
                  Add to Cart
                </button>
              </div>
            </div>
            <div className="exhibit-preview">
              <img src={exhibit.img} alt={exhibit.name} loading="lazy" />
            </div>
          </div>
        </section>

        <section className="product-section" ref={productsSectionRef}>
          <div className="section-header">
            <h2>Some of our Stupid Ideas </h2>
            <button
              className="refresh-btn"
              onClick={refreshProducts}
              disabled={!isServerReady || isLoading}
            >
              {serverStatus === 'connecting'
                ? 'Loading...'
                : (isLoading ? 'Refreshing...' : 'View More Products')}
            </button>
          </div>
          <div className="product-grid">
            {products.map((product, index) => (
              <article
                key={product.id}
                className="product-card"
                style={{ borderColor: shuffledBorderColors[index % shuffledBorderColors.length] }}
              >
                <div className="image-container">
                  {product.img ? (
                    <img src={product.img} alt={product.name} loading="lazy" />
                  ) : (
                    <div className="no-image-fallback">
                      <span>No image to load</span>
                    </div>
                  )}
                </div>
                <div className="product-copy">
                  <h2 className="product-name">{product.name}</h2>
                  <p className="product-desc">{product.desc}</p>
                </div>

                <div className="product-footer">
                  <span className="product-price">{formatPrice(productPriceFor(product.id))}</span>
                  <div className="product-actions">
                    <label className="qty-label">
                      Qty
                      <input
                        type="number"
                        min="1"
                        value={quantityById[product.id] ?? 1}
                        onChange={(event) => handleQuantityInput(product.id, event.target.value)}
                      />
                    </label>
                    <button
                      className="add-cart-btn"
                      onClick={() => updateCart(product, quantityById[product.id] ?? 1)}
                    >
                      Add to Cart
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>

          <div className="view-more-container">
            <button
              className="refresh-btn view-more-btn"
              onClick={refreshProducts}
              disabled={!isServerReady || isLoading}
            >
              {isLoading ? 'Procuring more junk...' : 'View More Products'}
            </button>
          </div>
        </section>
      </main>

      <footer className="footer">
        <p>© 2026 StupidDesigns.com. All rights reserved. Not that anyone actually wants them.</p>
      </footer>
      {statusVisible && (
        <div className={`status-toast ${serverStatus}`}>
          {serverStatus === 'connecting' && 'Connecting to servers...'}
          {serverStatus === 'connected' && 'Connected to server'}
          {serverStatus === 'failed' && 'Unable to connect to server.'}
        </div>
      )}
    </div>
  );
}

export default App;